var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEllipseUnfitScore = props => {
  const _uid = React.useId().replace(/:/g, '');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#" + _uid + "ellipse-unfit-score_svg__a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C81E1E",
    d: "M1.2 8a.84.84 0 0 0-.565.213.7.7 0 0 0-.235.514v2.182c0 .193.085.378.235.514.15.137.353.213.565.213a.84.84 0 0 0 .566-.213A.7.7 0 0 0 2 10.91V8.727a.7.7 0 0 0-.234-.514A.84.84 0 0 0 1.2 8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFDCDB",
    d: "M10.234.213A.84.84 0 0 1 10.8 0c.212 0 .416.077.566.213s.234.321.234.514V10.91a.7.7 0 0 1-.234.514.84.84 0 0 1-.566.213.84.84 0 0 1-.566-.213.7.7 0 0 1-.234-.514V.727c0-.193.084-.378.234-.514M7.034 3.122A.84.84 0 0 1 7.6 2.91c.212 0 .415.077.565.213.15.137.235.322.235.514v7.273a.7.7 0 0 1-.235.514.84.84 0 0 1-.565.213.84.84 0 0 1-.566-.213.7.7 0 0 1-.234-.514V3.636c0-.192.084-.377.234-.514M3.834 6.031a.84.84 0 0 1 .566-.213c.212 0 .415.077.565.213.15.137.235.322.235.514v4.364a.7.7 0 0 1-.235.514.84.84 0 0 1-.565.213.84.84 0 0 1-.566-.213.7.7 0 0 1-.234-.514V6.545c0-.192.084-.377.234-.514"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: _uid + "ellipse-unfit-score_svg__a"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v12H0z"
  })))));
};
export { SvgEllipseUnfitScore as ReactComponent };
export default __webpack_public_path__ + "a23ca80037478d762b8f40af728e3e3a.svg";